import { Injectable } from '@angular/core';

@Injectable({providedIn: 'root'})
export class SessionService {
    constructor() {
    }

    public store(key: string, value: any) {
        window.sessionStorage.setItem(key, JSON.stringify(value));
    }

    public fetch(key: string): any {
        const value = window.sessionStorage.getItem(key);
        return value ? JSON.parse(value) : null;
    }

    public remove(key: string): any {
        window.sessionStorage.removeItem(key);
    }
}
